import {Link} from 'react-router';
import React from 'react';

export default ({ to, children, tabIndex }) => {
  const additionalProps = tabIndex === '-1' ? { tabIndex: '-1' } : {};
  return to ? <Link to={to} { ...additionalProps }>{children}</Link> : children;
};


// WEBPACK FOOTER //
// ./src/components/shared/linkify.js